import UseContext from 'hooks/useContext';
import { useCallback, useMemo } from 'react';

// The slide-overs of a task (components/SlideOver/dataSlideOver).
export const TASK_PANEL = 'get_task';
export const TASK_FORM_PANEL = 'task_form';

/**
 * Opens a task's panel (`openTask(id)`, or `openTask(id, { tab: 'comments' })`
 * on another tab than its detail) or its form, empty or filled
 * (`openTaskForm({ taskId, defaults })`): the slide-over reads them in
 * `objID`, as the other panels of the admin do.
 */
const useTaskPanels = () => {
  const { setObjID, setSlideOverType, setSlideOverShow } = UseContext();
  const show = useCallback(
    (type, value) => {
      setObjID(value);
      setSlideOverType(type);
      setSlideOverShow(true);
    },
    [setObjID, setSlideOverType, setSlideOverShow],
  );
  return useMemo(
    () => ({
      openTask: (id, { tab } = {}) => show(TASK_PANEL, tab ? { taskId: id, tab } : id),
      openTaskForm: ({ taskId = null, defaults = {} } = {}) => show(TASK_FORM_PANEL, { taskId, defaults }),
    }),
    [show],
  );
};

export default useTaskPanels;
